export default __webpack_public_path__ + "static/10-3b9a9e0bb458d838c7c5fea9659b3488.jpg";